webpackJsonp([47137193634504],{

/***/ 2538:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/todomvc.425a1da6.png";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Example = __webpack_require__(33);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _todomvc = __webpack_require__(2538);
	
	var _todomvc2 = _interopRequireDefault(_todomvc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Example2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Todo MVC'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example is a Lore-specific implementation of the ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://todomvc.com/' },
	        'TodoMVC example'
	      ),
	      '. You can find the code ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples/todomvc' },
	        'in the Lore repository'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Screenshot'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _todomvc2.default }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Demonstrates'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This example demonstrates:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'Creating a model'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Connecting a component to the data store'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'CRUD Actions'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Running the Example'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      git clone https://github.com/lore/lore.git\n\n      cd lore/examples/todomvc\n      npm install\n      npm start\n\n      open http://localhost:3000/\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-todo-mvc-js-45582b5f1c8dcb62820e.js